// extracted by mini-css-extract-plugin
export var typingIndicator = "_np-0";